import React from 'react'
import { useDispatch } from 'react-redux'
import { chatReport } from '../redux/UserActions'

function Reports() {
    const dispatch = useDispatch()
    return (
        <div>
            <input id="id" />
            <button onClick={() => {
                dispatch(chatReport({ "id": document.getElementById("id").value }))
            }}>Chat Report</button>
        </div>
    )
}

export default Reports
